var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-wrap',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"preview-data":_vm.previewData}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPlayer),expression:"showPlayer"}],attrs:{"id":"video-container"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }